export const ENDMILE_API_EVENT_LIST = {
    VIRTUAL_TRIAL:'virtualbooktrial',
    BOOKSTORE:"BOOKSTORE",
	BOOKSTORE_PRODUCT_VIEWED:"BOOKSTORE_PRODUCT_VIEWED",
	BOOKSTORE_PRODUCT_CLICKED_ADD_TO_CARD:"BOOKSTORE_PRODUCT_CLICKED_ADD_TO_CARD",
	BOOKSTORE_PRODUCT_BUYNOW_CLICKED:"BOOKSTORE_PRODUCT_BUYNOW_CLICKED",
	BOOKSTORE_CHECKOUT_PROCEEDTOPAY_CLICKED:"BOOKSTORE_CHECKOUT_PROCEEDTOPAY_CLICKED",
	BOOKSTORE_PAYMENT_SUCCESSFULL:"BOOKSTORE_PAYMENT_SUCCESSFULL",
	BOOKSTORE_PAYMENT_INITIATED:"BOOKSTORE_PAYMENT_INITIATED",
	BOOKSTORE_PAYMENT_FAILED:"BOOKSTORE_PAYMENT_FAILED",
	BOOKSTORE_ORDER_CONFIRMED:"BOOKSTORE_ORDER_CONFIRMED",
    PAGE_VISITED: "PAGE_VISITED",
		PRODUCT_VIEWED: "PRODUCT_VIEWED",
		ADD_TO_CART: "ADD_TO_CART",
		BUY_NOW: "BUY_NOW",
		ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
		PROCEED_TO_CHECKOUT: "PROCEED_TO_CHECKOUT",
		PROCEED_TO_PAYMENT: "PROCEED_TO_PAYMENT",
		PAYMENT_INITIATED: "PAYMENT_INITIATED",
		PAYMENT_SUCCESSFUL: "PAYMENT_SUCCESSFUL",
		PAYMENT_FAILED: "PAYMENT_FAILED",
		ORDER_CONFIRMED: "ORDER_CONFIRMED",
		SIGN_UP_INITIATE: "SIGN_UP_INITIATE",
		SIGN_UP_CONFIRMED: "SIGN_UP_CONFIRMED",
		SIGNED_IN: "SIGNED_IN",
		STUDENT_REGISTRATION: "STUDENT_REGISTRATION",
		STUDENT_PURCHASED_AUTO: "STUDENT_PURCHASED_AUTO",
		ACTUAL_PAID: "ACTUAL_PAID",
		WEB_TRIAL: "WEB_TRIAL",
		QR_CODE:"QR_CODE",
		FREE_TRIAL: "FREE_TRIAL",
		STUDENT:"STUDENT",
		STUDENT_PRODUCT_VIEWED:"STUDENT_PRODUCT_VIEWED",
		STUDENT_PRODUCT_CLICKED_ADD_TO_CARD:"STUDENT_PRODUCT_CLICKED_ADD_TO_CARD",
		STUDENT_PRODUCT_BUYNOW_CLICKED:"STUDENT_PRODUCT_BUYNOW_CLICKED",
		STUDENT_CHECKOUT_PROCEEDTOPAY_CLICKED:"STUDENT_CHECKOUT_PROCEEDTOPAY_CLICKED",
		STUDENT_PAYMENT_INITIATED:"STUDENT_PAYMENT_INITIATED",
		STUDENT_PAYMENT_SUCCESSFULL:"STUDENT_PAYMENT_SUCCESSFULL",
		STUDENT_PAYMENT_FAILED:"STUDENT_PAYMENT_FAILED",
		STUDENT_ORDER_CONFIRMED:"STUDENT_ORDER_CONFIRMED",
		RESEARCH:"RESEARCH",
		RESEARCH_CHECKOUT_PROCEEDTOPAY_CLICKED:"RESEARCH_CHECKOUT_PROCEEDTOPAY_CLICKED",
		RESEARCH_PAYMENT_INITIATED:"RESEARCH_PAYMENT_INITIATED",
		RESEARCH_PAYMENT_SUCCESSFULL:"RESEARCH_PAYMENT_SUCCESSFULL",
		RESEARCH_PAYMENT_FAILED:"RESEARCH_PAYMENT_FAILED",
		PRACTICE:"PRACTICE",
		PRACTICE_CHECKOUT_PROCEEDTOPAY_CLICKED:"PRACTICE_CHECKOUT_PROCEEDTOPAY_CLICKED",
		PRACTICE_PAYMENT_INITIATED:"PRACTICE_PAYMENT_INITIATED",
		PRACTICE_PAYMENT_SUCCESSFULL:"PRACTICE_PAYMENT_SUCCESSFULL",
		PRACTICE_PAYMENT_FAILED:"PRACTICE_PAYMENT_FAILED",
		PRACTICE_ORDER_CONFIRMED:"PRACTICE_ORDER_CONFIRMED",
		USER_SIGNUP_LOGIN:"USER_SIGNUP_LOGIN",
		USER_SIGNUP_INITIATED:"USER_SIGNUP_INITIATED",
		USER_SIGNUP_CONFIRMED:"USER_SIGNUP_CONFIRMED",
		PREMIUM:"PREMIUM",
		PREMIUM_EVENT_VIEWED:"PREMIUM_EVENT_VIEWED",
		PREMIUM_CHECKOUT_PROCEEDTOPAY_CLICKED:"PREMIUM_CHECKOUT_PROCEEDTOPAY_CLICKED",
		PREMIUM_PAYMENT_INITIATED:"PREMIUM_PAYMENT_INITIATED",
		PREMIUM_PAYMENT_SUCCESSFULL:"PREMIUM_PAYMENT_SUCCESSFULL",
		PREMIUM_PAYMENT_FAILED:"PREMIUM_PAYMENT_FAILED",
		PREMIUM_ORDER_CONFIRMED:"PREMIUM_ORDER_CONFIRMED",
		LEARNING:"LEARNING",
		LEARNING_EVENT_VIEWED:"LEARNING_EVENT_VIEWED",
		LEARNING_CHECKOUT_PROCEEDTOPAY_CLICKED:"LEARNING_CHECKOUT_PROCEEDTOPAY_CLICKED",
		LEARNING_PAYMENT_INITIATED:"LEARNING_PAYMENT_INITIATED",
		LEARNING_PAYMENT_SUCCESSFULL:"LEARNING_PAYMENT_SUCCESSFULL",
		LEARNING_PAYMENT_FAILED:"LEARNING_PAYMENT_FAILED",
		LEARNING_ORDER_CONFIRMED:"LEARNING_ORDER_CONFIRMED",
		LEARNING_CTA_CLICKED:"LEARNING_CTA_CLICKED",
		LEARNING_REGISTER_FREE_EVENT_SESSION:"LEARNING_REGISTER_FREE_EVENT_SESSION"
}

export const ENDMILE_API_FIELD_ID_MAPPING_LIST = {
    FIRST_NAME_LAST_NAME: 'FIRST_NAME_LAST_NAME',
    PRODUCT_SERVICES:'PRODUCT_SERVICES',
    ACTIVATON_DATE: 'ACTIVATON_DATE',
    EXPIRY_DATE:'EXPIRY_DATE',
    PHONE_NUMBER: 'PHONE_NUMBER',
    LOCATION:'LOCATION',
    CITY:'CITY ',
    DESGNATION:'DESGNATION',
    PROFESSION:'PROFESSION',
    CID:'CID',
    PRODUCT_SUB_CATEGORY:'PRODUCT_SUB_CATEGORY',
    PRODUCT_NAME:'PRODUCT_NAME',
    AREA_OF_SPECIALIZATION:'AREA_OF_SPECIALIZATION',
    STATE:'STATE',
    PAGE_URL:'PAGE_URL',
    PAGE_CATEGORY:'PAGE_CATEGORY',
    PAGE_TITLE:'PAGE_TITLE',
    PRODUCT_ID: "PRODUCT_ID",
   PRODUCT_TYPE:"PRODUCT_TYPE",
   CART_SIZE:'CART_SIZE',
   ORDER_VALUE:'ORDER_VALUE',
   PAYMENT_MODE:'PAYMENT_MODE',
   PROMO_CODE:'PROMO_CODE',
   TRANSACTION_ID:'TRANSACTION_ID',
   TRANSACTION_AMOUNT:'TRANSACTION_AMOUNT',
   TRANSACTION_DATE:'TRANSACTION_DATE',
   TRANSACTION_TIME:'TRANSACTION_TIME',
   PAYMENT_METHOD:'PAYMENT_METHOD',
   ORDER_ID:'ORDER_ID',
   ORDER_AMOUNT:'ORDER_AMOUNT',
   ORDER_DATE:'ORDER_DATE',
   ORDER_TIME:'ORDER_TIME',
   COURSE:'COURSE',
   COURSE_LEVEL:'COURSE_LEVEL',
   YEAR_OF_ATTEMPT:'YEAR_OF_ATTEMPT',
   MONTH_OF_ATTEMPT:'MONTH_OF_ATTEMPT',
   COURSE_SUBJECT:'COURSE_SUBJECT',
   PRODUCT_CATEGORY: 'PRODUCT_CATEGORY',
   EXAM: 'EXAM',
   INSTITUTES: 'INSTITUTES'
}

export const ENDMILE_API_CONSTANT = {
    CID:'cid',
    INTERNAL:'internal',
    OID:'OID',
    TID:'TID'
}